import type { IProductSubscriptionRepository } from '../IProductSubscriptionRepository';
import type {
  ProductSubscriptionDTO,
  ProductSubscriptionFilter,
} from '../productSubscription.types';
import { injectable } from 'inversify';
import qs from 'qs';
import API from '@repositories/Axios';
import type { Page } from '@type/Page';

@injectable()
export class ProductSubscriptionRepository implements IProductSubscriptionRepository {
  async getList(queries?: ProductSubscriptionFilter): Promise<Page<ProductSubscriptionDTO>> {
    const queryString = qs.stringify(queries, {
      arrayFormat: 'repeat',
      skipNulls: true,
    });
    const result = await API.get<Page<ProductSubscriptionDTO>>(
      `/api/v1/product-subscriptions?${queryString}`,
    );
    return result.data;
  }
}
